<template>
    <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="8.5" r="1.5" fill="currentColor"/>
        <circle cx="11" cy="8.5" r="1.5" fill="currentColor"/>
        <circle cx="17" cy="8.5" r="1.5" fill="currentColor"/>
    </svg>

</template>

<script>
export default {
    name: 'SVGOptions',
};
</script>

<style scoped lang="scss">

</style>
